import { Table } from "react-bootstrap";
import CreatableSelect from "react-select/creatable";
import React, { Component } from "react";
import { CircularProgress } from "@material-ui/core";
import db, { storage } from "../firebase";
import { notify } from "react-notify-toast";
import Select from "react-select";
import { LinearProgress } from "material-ui";

export default class BranchBulkUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("Ubytes")),
      branches: [
        {
          branchName: "",
          branchEmail: "",
          branchContact: "",
          address: "",
          brandBanner: null,
        },
      ],
    };
  }
  componentDidMount() {
    if (this.state.user.role === "Superadmin") {
      this.loadMerchant();
    }
    if (this.state.user.role === "Merchant") {
      this.loadMerchant(this.state.user.uid);
    }
  }
  loadMerchant = async (uid = false) => {
    if (uid) {
      let doc = await db.collection("Merchant").doc(uid).get();
      this.setState({ selectedMerchant: doc.data() });
      return;
    }
    let merchants = await db.collection("Merchant").get();
    let mList = [];
    merchants.forEach((m) => {
      let _ = m.data();
      _["value"] = m.data().brandName;
      _["label"] = m.data().brandName;
      mList.push(_);
    });

    this.setState({ merchants: mList });
  };
  addBranch = () => {
    let payload = this.state.branches;
    payload.push({
      branchName: "",
      branchEmail: "",
      branchContact: "",
      address: "",
      brandBanner: null,
    });
    this.setState({ branches: payload });
  };
  imageUrl = (f) => {
    let url = URL.createObjectURL(f);

    return url;
  };
  updateContent = (info, index, label) => {
    let branch = this.state.branches;
    branch[index][label] = info;
    this.setState({ branches: branch });
  };
  loadBranch = async () => {
    let user = this.state.user;
    let branches = await db
      .collection("Branches")
      .where(
        "of",
        "==",
        user.role === "Merchant" ? user.uid : this.state.selectedMerchant.uid
      )
      .get();
    let branchList = [];
    branches.forEach((branch) => {
      let _ = branch.data();
      _["value"] = branch.data().branchName;
      _["label"] = branch.data().branchName;
      branchList.push(_);
    });
    this.setState({ branches: branchList });
  };
  upload = async () => {
    this.setState({ loading: true });
    if (this.state.branches.length <= 0) {
      notify.show("Please add a branch", "warning");
      return;
    }

    await this.state.branches.forEach(async (branch, index) => {
      this.setState({ loading: true });
      let payload = branch;
      let user = this.state.user;

      const image = payload.brandBanner;

      if (
        payload.branchName === "" ||
        payload.branchContact === "" ||
        payload.address === "" ||
        payload.branchEmail === ""
      ) {
        notify.show(`Please fill data properly in ${index}th row`, "error");
        return;
      }
      if (user.role === "Merchant") {
        payload["of"] = this.state.user.uid;
        payload["ofMerchant"] = this.state.user.uid;
      } else if (user.role === "Superadmin") {
        if (!this.state.selectedBranch && !this.state.selectedMerchant) {
          notify.show(
            "Please select a branch and a merchant Properly",
            "warning"
          );
          return;
        }
        payload["of"] = this.state.selectedBranch.branchId;
        payload["ofMerchant"] = this.state.selectedMerchant.uid;
      }

      payload.brandBanner = "";
      await db
        .collection("Branches")
        .add(payload)
        .then(async (doc) => {
          const ref = storage.ref("branchBanner/" + doc.id);
          const url = await ref.put(image);
          const image_ = await url.ref.getDownloadURL();

          console.log(this.state.loading);
          await doc.update({ branchId: doc.id, brandBanner: image_ });
          this.setState({
            progress: (index / this.state.branches.length) * 100,
          });

          notify.show(`${branch.branchName} updated successfully`, "success");
        });
    });

    this.setState({ loading: false });
  };

  deleteRow = (index) => {
    let payload = this.state.branches;
    payload.pop(index);
    this.setState({ branches: payload });
  };
  render() {
    return (
      <div className="productBulkUploadBody">
        <div className="bsc">
          {this.state.user.role === "Superadmin" ? (
            <Select
              placeholder="Select Merchant"
              options={this.state.merchants}
              onChange={(e) => this.setState({ selectedMerchant: e })}
            ></Select>
          ) : null}
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <td>Id</td>
              <td>Branch Name</td>
              <td>Branch Email</td>

              <td>Branch Contact</td>
              <tb>Branch Address</tb>
              <td>Brand Banner</td>
              <td>Delete</td>
            </tr>
          </thead>
          <tbody>
            {this.state.branches.map((branch, index) => {
              return (
                <tr key={branch.productId} className="product-bulk-rows">
                  <td>{index + 1}</td>
                  <td>
                    <input
                      value={branch.branchName}
                      placeholder="Branch Name"
                      onChange={(e) =>
                        this.updateContent(e.target.value, index, "branchName")
                      }
                    ></input>
                  </td>
                  <td>
                    <input
                      type="email"
                      value={branch.branchEmail}
                      onChange={(e) =>
                        this.updateContent(e.target.value, index, "branchEmail")
                      }
                      placeholder="Branch Email"
                    ></input>
                  </td>
                  <td>
                    <input
                      value={branch.branchContact}
                      type="number"
                      onChange={(e) =>
                        this.updateContent(
                          e.target.value,
                          index,
                          "branchContact"
                        )
                      }
                      placeholder="Branch Contact"
                    ></input>
                  </td>
                  <td>
                    <input
                      value={branch.address}
                      onChange={(e) =>
                        this.updateContent(e.target.value, index, "address")
                      }
                      placeholder="Branch address"
                    ></input>
                  </td>
                  <td>
                    {branch.brandBanner ? (
                      <img
                        src={this.imageUrl(branch.brandBanner)}
                        style={{ width: "50px", height: "50px" }}
                      ></img>
                    ) : (
                      <input
                        type="file"
                        value={branch.brandBanner}
                        onChange={(e) =>
                          this.updateContent(
                            e.target.files[0],
                            index,
                            "brandBanner"
                          )
                        }
                      ></input>
                    )}
                  </td>
                  <td>
                    <button
                      style={{ backgroundColor: "tomato" }}
                      onClick={() => this.deleteRow(index)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <button onClick={this.addBranch}>Add</button>

        {this.state.loading ? (
          <LinearProgress
            value={this.state.progress}
            variant="buffer"
          ></LinearProgress>
        ) : (
          <button onClick={this.upload}>Upload</button>
        )}
      </div>
    );
  }
}
